import React from 'react';

import StatFigureTile from 'CommonComponents/StatFigureTile';

/**
 * Whole-organisation counts: they ignore the filters and leave out
 * deactivated members.
 */
export default function OrganisationUserTiles({ tiles }) {
    return (
        <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-3 xl:tw-grid-cols-6 tw-gap-4">
            <StatFigureTile value={tiles?.users_in_organisation} label={$t('Users in organisation')} />
            <StatFigureTile value={tiles?.active} label={$t('Active')} />
            <StatFigureTile value={tiles?.invited_not_accepted} label={$t('Invited, not yet accepted')} attention />
            <StatFigureTile value={tiles?.never_logged_in} label={$t('Never logged in')} attention />
            <StatFigureTile value={tiles?.logged_in_last_7_days} label={$t('Logged in last 7 days')} />
            <StatFigureTile value={tiles?.active_without_mfa} label={$t('Active without MFA')} attention />
        </div>
    );
}
